// Public - Marketing - Homepage
// ----------------------
import React from 'react'
import {
  Segment
} from 'semantic-ui-react'

//import HomepageHeroSimple from '../../../components/public/homepage-hero-simple/homepage-hero-simple'
import HomepageHeroScrolling from '../../../components/public/homepage-hero-scrolling/homepage-hero-scrolling'
//import HomepageHero from '../../../components/public/homepage-hero/homepage-hero'
//import HomepageBenefits from '../../../components/public/homepage-benefits/homepage-benefits'
import HomepageMarketing from '../../../components/public/homepage-marketing/homepage-marketing'
import HomepagePodcastSubmit from '../../podcast-submit/homepage-podcast-submit/homepage-podcast-submit'

// styles
import styles from './homepage.module.scss';


export default function Homepage() {
  return (
    <>
      <Segment basic id="home" className={styles.homepage_view}>
        <HomepageHeroScrolling />
        {/* <HomepageHeroSimple /> */}
        {/* <HomepageBenefits /> */}
        <HomepageMarketing />
        <HomepagePodcastSubmit />
      </Segment>
    </>
  )
}